module.exports = __webpack_public_path__ + "img/bott2.e81cf35e.png";